export const useIsAdminLoggedIn = () => {
  // TODO Add extra validation from Firebase side
  return !!localStorage.getItem("admin-token");
};
